/**
 * Configure restangular the framework to connect the backend
 */
module.run([ 'Restangular', '$state', 'alertService', 'securityService', '$window', 'editableOptions', function(Restangular, $state, alertService, securityService, $window, editableOptions) {

	var outputLog = false;

	editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2',

	Restangular.setDefaultHeaders({
		'Accept' : 'application/json'
	});
	Restangular.setDefaultHeaders({
		'Content-Type' : 'application/json'
	});
	Restangular.setFullResponse(true);

	/* Configure the api host */
	var restApiPort = "";
	if (frontEndProperties.port) {
		if (frontEndProperties.port.length > 0) {
			restApiPort = ":" + frontEndProperties.port;
		}
	}

	var urlRestApi = frontEndProperties.host + restApiPort + frontEndProperties.baseUrl;
	if (outputLog)
		console.log('REST API:' + urlRestApi);
	Restangular.setBaseUrl(urlRestApi);

	/* Generic error handler when request the backend */
	Restangular.setErrorInterceptor(function(response, deferred, responseHandler) {
		if (outputLog)
			console.log('interceptor del error en RESTANGULAR');
		if (outputLog)
			console.log(response);
		var errorDetail = "Mensaje de error no especificado";

		var data = response.data;
		if (data != null) {
			errorDetail = data.message;
		}

		if (response.status === 0) {
			alertService.showDanger('No hay conexión con el servidor, revise su conexión a Internet o comuníquese con un administrador.', response.status);
		} else if (response.status === 400) {
			alertService.showDanger('Solicitud incorrecta. Detalle del error: ' + errorDetail, response.status);
		} else if (response.status === 401) {
			var userResponse = function() {
				securityService.logOut();
			}

			alertService.showSwtQuestion('Sin sesión, es posible que haya expirado o sus credenciales de autenticación NO son válidas. Detalle del error: ' + errorDetail, userResponse);

		} else if (response.status === 403) {
			alertService.showDanger('Acceso denegado. Posible causa: Usuario o password incorrecto o usuario no tiene permiso para ejecutar esta funcionalidad. Detalle del error: ' + errorDetail, response.status);
		} else if (response.status === 404) {
			alertService.showDanger('Recurso no encontrado. Detalle del error: ' + errorDetail, response.status);
		} else if (response.status === 406) {
			alertService.showDanger('Validación en el servidor incorrecta, revise los campos del formulario . Detalle del error: ' + errorDetail, response.status);
		} else if (response.status === 409) {
			alertService.showDanger('Conflicto con el estado actual de la aplicación. Detalle del error: ' + errorDetail, response.status);
		} else if (response.status === 412) {
			alertService.showDanger('Restricción de negocio no se cumple . Detalle del error: ' + errorDetail, response.status);
		} else if (response.status === 500) {
			alertService.showDanger('Error interno de la aplicación, comuníquese con un administrador. Detalle del error: ' + errorDetail, response.status);
		}
		return true; // error not handled
	});
	
} ]);

module.run(function(amMoment) {
	amMoment.changeLocale('es');

	var currentCalendar = moment.localeData('es')._calendar;
	currentCalendar.sameElse = 'dddd, MMMM D YYYY, h:mm a';
	var currentDateFormat = moment.localeData('es')._longDateFormat;
	currentDateFormat.LT = 'h:mm a';
	moment.locale('es', currentCalendar);
	moment.locale('es', currentDateFormat);
	moment.locale('es');

});

module.constant('LOCALES', {
	'locales' : {
		'en_US' : 'English',
		'es_CO' : 'Español'
	},
	'preferredLocale' : 'es_CO'
})

module.run([ '$rootScope', 'Permission', 'Identity', 'alertService', '$state', function($rootScope, Permission, Identity, alertService, $state) {

	Permission.defineRole('anonymous', function(stateParams) {
		// If the returned value is *truthy* then the user has the role,
		// otherwise they don't
		return false;
	});

	Permission.defineManyRoles(ROLE_TYPE.codes(), function(stateParams, roleCode) {
		return Identity.hasRole(roleCode);
	});

	$rootScope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams) {

		//console.log(toState);
		if (toState.name == "home.dashboard") {
			if (Identity.hasRole(ROLE_TYPE.COMMERCIAL_MANAGER.code)) {
				e.preventDefault();
				$state.go("home.dashboardCM", toParams, {
					location : 'replace'
				});
			} else if (Identity.hasRole(ROLE_TYPE.CLIENT.code)) {
				e.preventDefault();
				$state.go("home.dashboardClient", toParams, {
					location : 'replace'
				});
			} else if(Identity.hasRole(ROLE_TYPE.PROGRAMMING_COORDINATOR.code)) {
				e.preventDefault();
				toParams.states = ['WAITING_FOR_SCHEDULE','SCHEDULED','ASIGNED'];
				$state.go("home.sampleSchedule", toParams, {
					location : 'replace'
				});
			} else if(Identity.hasRole(ROLE_TYPE.SAMPLES_PROFESSIONAL.code)) {
				e.preventDefault();
				$state.go("home.professionalSamplingTask", toParams, {
					location : 'replace'
				});
			} else if(Identity.hasRole(ROLE_TYPE.SAMPLE_RECEIVER.code)) {
				e.preventDefault();
				$state.go("home.sampleReceive", toParams, {
					location : 'replace'
				});
			} else if(Identity.hasRole(ROLE_TYPE.LABORATORY_PROFESSIONAL.code)) {
				e.preventDefault();
				$state.go("home.sampleAnalyze", toParams, {
					location : 'replace'
				});
			}  else if(Identity.hasRole(ROLE_TYPE.TECHNICAL_PROFESSIONAL.code)) {
				e.preventDefault();
				$state.go("home.sampleInterpret.select", toParams, {
					location : 'replace'
				});
			}  else if(Identity.hasRole(ROLE_TYPE.ACCOUNTING.code)) {
				e.preventDefault();
				$state.go("home.reportHome", toParams, {
					location : 'replace'
				});
			} 

		}
	});

	$rootScope.$on('$stateChangePermissionDenied', function(toState, toParams, options) {
		$state.go('home.dashboard');
	});

} ]);

/**
 * Function to configure pagination custom template
 */
module.config(function(paginationTemplateProvider) {
	paginationTemplateProvider.setPath('views/templates/customPagination.tpl.html');
});

module.config([ 'ngToastProvider', function(ngToastProvider) {
	ngToastProvider.configure({
		animation : 'slide', // or 'fade'
		verticalPosition : 'bottom',
		timeout : '5000'
	});
} ]);

module.config(function (localStorageServiceProvider) {
	  localStorageServiceProvider.setPrefix('azul');
	  localStorageServiceProvider.setStorageType('localStorage');
	  localStorageServiceProvider.setNotify(true, true);
	});

/**
 * Function to add an interceptor to the navigation. If there is not a session
 * the user must be redirected to the login page
 */
module.config([ '$stateProvider', '$urlRouterProvider', 'ipnConfig', function($stateProvider, $urlRouterProvider, ipnConfig) {

	ipnConfig.defaultCountry = 'co';

	initSecurityStates($stateProvider);
	initCoreStates($stateProvider);
	initClntStates($stateProvider);
	initProdStates($stateProvider);
	initSamplStates($stateProvider);
	initRptStates($stateProvider);
	initNtfStates($stateProvider);

	$urlRouterProvider.otherwise(function($injector, $location) {
		var $state = $injector.get("$state");
		$state.go("home.dashboard");
	});

} ]);

module.value('selectizeConfig', {
	delimiter : '|',
	placeholder : ''
});

module.value('duScrollBottomSpy', true);

module.factory('authInterceptor', [ '$q', 'Auth', 'alertService', 'Identity', '$injector', function($q, Auth, alertService, Identity, $injector) {
	var outputLog = false;
	
	return {
		request : function(request) {
			if(request.url.indexOf(frontEndProperties.baseUrl) != -1){ // Intercept only request to backend
				
				if (Auth.authz.token) { // If user is logged then there must be a token to refresh or validate
					
					if(Auth.authz.isTokenExpired(20)){ 
						var deferred = $q.defer();
						
						Auth.authz.updateToken(20).success(function() {
								
							if (Identity.authorization && Identity.authorization.rpt && request.url.indexOf('/authorize') == -1) {
								retries = 0;
								request.headers.Authorization = 'Bearer ' + Identity.authorization.rpt;
							} else {
								request.headers.Authorization = 'Bearer ' + Auth.authz.token;
							}

							deferred.resolve(request);
						}).error(function() {
							console.log('authInterceptor.request() url:' + request.url + ', refresco fallido');
							location.reload();
						});
						
						return deferred.promise;
					}
					else{
						if (Identity.authorization && Identity.authorization.rpt && request.url.indexOf('/authorize') == -1) {
			                retries = 0;
			                request.headers.Authorization = 'Bearer ' + Identity.authorization.rpt;
			            } else {
			                request.headers.Authorization = 'Bearer ' + Identity.authc.token;
			            }
						return request;
					}
					
				} else {
					return request;
				}
			}
			else{
				return request;
			}
			
		},
		responseError : function(rejection) {
			if (outputLog){
				console.log('authInterceptor.responseError() BEGIN >>');
				console.log(rejection);
			}
				
			var status = rejection.status;

			if (status == 403 || status == 401 || status == -1) {
				var retry = (!rejection.config.retry || rejection.config.retry < 1);

				if (!retry) {
					return $q.reject(rejection);
				}

				if (rejection.config.url.indexOf('/authorize') == -1 && retry) {
					var deferred = $q.defer();

					// override WWW-Authenticate header when backend and frontend has different domains, this feature is not
					// supported by Keycloak completely yet.   
					var authenticateHeader = 'KC_ETT realm="asebiol-rest-api",as_uri="' + auth.authz.authServerUrl + '/auth/realms/' + auth.authz.realm + '/authz/entitlement"';

					// here is the authorization logic, which tries to
					// obtain an authorization token from the server in
					// case the resource server
					// returns a 403 or 401.
					Identity.authorization.authorize(authenticateHeader).then(function(rpt) {
						if (outputLog){
							console.log('authInterceptor.responseError() autorizacin correcta');
						}
							
						deferred.resolve(rejection);
					}, function() {
						console.log('You can not access or perform the requested operation on this resource.');
					}, function() {
						console.log('Unexpected error from server.');
					});

					var promise = deferred.promise;

					return promise.then(function(res) {
						if (!res.config.retry) {
							res.config.retry = 1;
						} else {
							res.config.retry++;
						}

						var $http = $injector.get("$http");

						if (outputLog){
							console.log('authInterceptor.responseError() END <<');
						}
						
						return $http(res.config).then(function(response) {
							return response;
						});
					});
				}
			}
			
			if (outputLog){
				console.log('authInterceptor.responseError() END <<');
			}

			return $q.reject(rejection);
		}
	};
} ]);

module.config(['$httpProvider', function($httpProvider) {
	$httpProvider.interceptors.push('authInterceptor');
}]);
